import { connect } from 'react-redux';
import { ApplicationState } from '../../store';
import * as Admin from '@store/admin';

import { AdminWorkMessages } from '@components/admin/AdminWorkMessages';

export default connect(
    (state: ApplicationState) => ({
        ...Admin.plainActions,
    }),
    Admin.actionCreators,
)(AdminWorkMessages as any) as any; // eslint-disable-line @typescript-eslint/no-explicit-any
